const blocks = document.querySelectorAll( '.wp-block-yoast-faq-block' );

blocks.forEach( block => {
    let sections = block.querySelectorAll( '.schema-faq-section' );

    sections.forEach( section => {
        const el = document.createElement( 'button' );
        el.classList = section.classList;
        el.id = section.id;
        el.role = 'button';
        el.ariaLabel = 'Toggle';
        el.innerHTML = section.innerHTML;
        section.replaceWith( el );

        requestAnimationFrame( () => el.addEventListener( 'click', toggleAnswer ) );
    } );

    sections = block.querySelectorAll( '.schema-faq-section' );

    toggleAnswer( { currentTarget: false } );

    function toggleAnswer( e ) {
        sections.forEach( section => {
            const content = section.querySelector( '.schema-faq-answer' );
            if ( section === e.currentTarget ) {
                jQuery( content ).slideToggle();
                section.classList.toggle( 'active' );
            } else {
                jQuery( content ).slideUp();
                section.classList.remove( 'active' );
            }
        } );
    }
} );